import React, { useState, useEffect } from "react";
import styled from "styled-components"

import Layout from "../components/layout"
import Container from "../components/container"

import FestivalPreview from "../components/festival-preview"
import ShowFeatured from "../components/show-featured";
import ShowListing from "../components/shows-listing"

import { getAllShows } from "../shows"
import { Link } from "react-router-dom";
import TicketsButton from "../components/button-tickets";

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Shows = styled.section`
  margin-bottom: 100px;

  h2, h3 {
    text-align: center;
  }
`
const UpcomingShow = styled.section`
`

function MastersPage(props) {  
  const [upcomingShow, setUpcomingShow] = useState(null);
  const [shows, setShows] = useState([]);
  const [pastShows, setPastShows] = useState([]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/speaker-series", title: "Speaker Series"});
  }, []);

  useEffect(() => {
    const orderedShows = getAllShows().filter(s => s.mastersAtMarshall);
    const upcomingShows = [];
    const oldShows = [];
    const today = new Date();

    today.setHours(0,0,0,0);

    for (const show of orderedShows) {
      if (show.date < today && (!show.endDate || show.endDate < today))
        oldShows.push(show);
      else
        upcomingShows.push(show);
    }

    setShows(upcomingShows);
    setPastShows(oldShows);
  }, []);

  return (
    <Layout page="masters" title="Speaker Series">
      {upcomingShow && 
        <UpcomingShow>
          <ShowFeatured show={upcomingShow} />
        </UpcomingShow>
      }

      <Container>
        <h2>Introducing the Masters at Marshall Distinguished Speaker Series</h2>
        <p>
            This new series will bring some of the brightest minds and influential
            voices to Marshall University. The goal is to stimulate dialogue, innovation
            and collaboration by offering a wide range of topics to spark your curiosity.
        </p>
        {(shows.length > 0) && 
          <div>
            <TicketsButton show={{
              tickets: shows[0].mastersAtMarshallTickets
            }}/>
          </div>
        }
        
      </Container>

      <Shows>
        {(shows.length > 0) && <h2>Upcoming Shows</h2>}

        {shows.map((show, index) => {
            return (
              <div key={index}>
                  <show.previewTemplate show={show} masters />
              </div>
            )
        })}   

        {(pastShows && pastShows.length > 0) && 
          <Container>
            <ShowListing 
              heading="Past Shows"
              shows={pastShows} 
            />
          </Container>
        }
      </Shows>  
    </Layout>
  );
}

export default MastersPage;